import { BreakPointCondition, useBreakpointIf, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { DrawerScreenProps } from '@react-navigation/drawer';
import { View } from 'native-base';
import React, { useCallback } from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { SignedInRootStackParamList } from '../../routes/types';

import { SubscriptionHeader } from './components/SubscriptionHeader';
import { SubscriptionList } from './components/SubscriptionList';

const styles = StyleSheet.create({
  contentComponentStyle: { flex: 1 },
});

export const Subscription: React.FC<
  DrawerScreenProps<SignedInRootStackParamList, 'Subscription'>
> = ({ navigation }) => {
  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');

  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
    return navigation.navigate('Cockpit');
  }, [navigation]);

  return (
    <ScrollView style={styles.contentComponentStyle} showsHorizontalScrollIndicator={false}>
      <View
        p={Spacing['inset.xs']}
        flex={1}
        width="full"
        maxWidth={{ base: '100%', sm: '95%', lg: '1280px' }}
        minWidth={0}>
        <VStack space={Spacing['stack.xxs']} flex={1} width="full">
          <SubscriptionHeader isMobile={isMobile} onReturn={goBack} />
          <SubscriptionList isMobile={isMobile} />
        </VStack>
      </View>
    </ScrollView>
  );
};
